/* eslint-disable max-classes-per-file */
import { CatalogTagsTranslation } from '../../modelViewer/Data/catalogTagsTranslation';
import { ModelRuleType } from './modelRuleType';

// This represents a set of selected options for a certain group
export class ModelRuleGroupData {

  groupID: number | undefined;
  options: number[] = [];
}

// DOMAINS

// This represents a domain group of a rule
// A domain rule, will have several of these
export class ModelRuleDomainGroupData {

  id : number | undefined;
  name : string | undefined;
  thumbnailRef: string | undefined;
  imagePath: string | undefined;
  conditions : ModelRuleGroupData[] = [];

  // Augmented translation
  public tagTranslation : CatalogTagsTranslation | undefined;
}

// This represents the properties of a rule if the rule type is Domain
export class ModelRuleDomainData {
  domainGroups : ModelRuleDomainGroupData[] = [];

  // Augmented translation
  public tagTranslation : CatalogTagsTranslation | undefined;
}

// Dependencies

export class ModelRuleDependenciesData {
  conditions : ModelRuleGroupData[] = [];
  actions: ModelRuleGroupData[] = [];
}

// FILTERS

// This represents the properties of a rule if the rule type is Filter
export class ModelRuleFilterData {
  conditions : ModelRuleGroupData[] = [];
  actions: ModelRuleGroupData[] = [];
}

// PROPERTIES

// This class represents a value to be set in a property
// if the conditions match
export class ModelRuleDescriptionData {
  propertyID: number | undefined;
  value: string | undefined;
}

// This represents the properties of a rule if the rule type is Properties
export class ModelRulePropertiesData {
  conditions : ModelRuleGroupData[] = [];
  descriptions: ModelRuleDescriptionData[] = [];
}

// This represents a single rule associated to a model
export class ModelRuleData {
  // Identification
  public _id: string | undefined;

  // RuleID
  public ruleID : number | undefined;

  // ModelID
  public modelID: string | undefined;

  // Rule priority (lower number means higher priority)
  public priority: number | undefined;

  // Properties
  public name: string | undefined;
  public description: string | undefined;
  public enabled: boolean | undefined;
  public type : ModelRuleType | undefined;

  // Rule properties
  public ruleDataDomain : ModelRuleDomainData | undefined;
  public ruleDataFilter : ModelRuleFilterData | undefined;
  public ruleDataDependencies : ModelRuleDependenciesData | undefined;
  public ruleDataProperties : ModelRulePropertiesData | undefined;
}
